const ASSET = "https://customer-assets-7cd3h4nn.emergentagent.net/job_welcome-guide-str/artifacts";

export const WEDDING_PHOTOS = [
  { url: `${ASSET}/5bf5bdc0891ab4d5_Sunlit%20Garden%20Wedding%20Ceremony.png`, alt: "Garden ceremony arch with florals on the Pebble Farms grounds" },
  { url: `${ASSET}/e660ba3ce9545656_Joyful%20Wedding%20Dance%20on%20the%20Driveway.png`, alt: "Wedding party celebrating on the drive" },
  { url: `${ASSET}/f7aa96b24b1549fc_Bridal%20Preparation%20in%20an%20Elegant%20Bedroom.png`, alt: "Bridal party getting ready in the primary suite" },
  { url: `${ASSET}/2c52dfd99a2b561f_Elegant%20Bridal%20Bathroom%20Preparations.png`, alt: "Hair and makeup in the primary bathroom" },
  { url: `${ASSET}/48313e6d7a81c88a_Elegant%20Garden%20Wedding%20Bar.png`, alt: "Outdoor bar setup among the crepe myrtles" },
  { url: `${ASSET}/316b499c848b870d_Groomsmen%20Strolling%20Through%20Blooming%20Gardens.png`, alt: "Groom and groomsmen strolling the blooming grounds" },
];

export const WEDDING_FAQS_GENERIC = [
  { q: "Can we bring our own vendors?", a: "Yes — outside caterers and vendors are welcome. Vendor-insurance requirements apply, and a preferred-vendor list is available from the host." },
  { q: "How many guests can attend?", a: "Event attendance is set with the host during the approval process — it's separate from overnight stay limits. Larger events include a coordinated parking attendant (additional fee)." },
  { q: "Is a coordinator available?", a: "Yes — a dedicated coordinator is available for celebrations at our venues. Details are confirmed during planning." },
  { q: "How do we hold our date?", a: "Send an event inquiry below or call/text (210) 274-3556. Dates are held under a separate event agreement with a deposit." },
];

export const VENUES = [
  {
    slug: "pebble-farms",
    name: "Pebble Farms",
    location: "Canyon Lake, Texas",
    tagline: "8 rustic acres with a waterfall pool, covered patio, and country grounds made for gathering.",
    capacity: "Weddings & gatherings · by host approval",
    hero: WEDDING_PHOTOS[0],
    photos: WEDDING_PHOTOS,
    site: "/",
    faqs: [
      { q: "Where do ceremonies take place at Pebble Farms?", a: "Most couples choose the open country grounds with the farmhouse as a backdrop, or the covered patio. During planning we'll walk the 8 acres with you to find your spot." },
      { q: "What's the rain plan?", a: "The covered patio is the built-in weather backup. For larger setups, we'll talk through contingency plans with you during planning so a forecast never ruins the day." },
      ...WEDDING_FAQS_GENERIC,
    ],
    details: [
      "Country grounds, a covered patio, and ample on-site parking",
      "Every event is arranged on its own with the host — advance approval required",
      "Separate event agreement; event fees, deposit, and vendor-insurance requirements confirmed with the host",
      "Larger events require a parking attendant (additional fee)",
    ],
  },
  {
    slug: "grandview-estate",
    name: "Grandview Estate",
    location: "Canyon Lake, Texas",
    tagline: "The flagship lakefront estate — sweeping water views and room for the whole celebration.",
    capacity: "Weddings & gatherings · by host approval",
    hero: null,
    photos: [],
    site: "https://grandview.elitestrhostingco.com",
    details: [
      "Lakefront setting with panoramic Canyon Lake views",
      "Host-approved weddings and gatherings",
      "Full details and availability on the Grandview site",
    ],
  },
  {
    slug: "eden-ranch",
    name: "Eden Ranch",
    location: "Texas Hill Country",
    tagline: "Ranch charm for celebrations — details and photography coming soon.",
    capacity: "Weddings & gatherings · coming soon",
    hero: null,
    photos: [],
    comingSoon: true,
    site: null,
    details: ["Ask the team about celebrations here — full details are on the way."],
  },
  {
    slug: "hilts",
    name: "Hilts",
    location: "Texas Hill Country",
    tagline: "Our newest gathering place — details and photography coming soon.",
    capacity: "Weddings & gatherings · coming soon",
    hero: null,
    photos: [],
    comingSoon: true,
    site: null,
    details: ["Ask the team about celebrations here — full details are on the way."],
  },
];

export const HUB_BRAND = {
  name: "Elite STR Hosting Co.",
  phone_display: "(210) 274-3556",
  phone_tel: "+12102743556",
};
